import { useRef, useState } from 'react'
import { ShareIcon } from '~/components/icons'
import { useClickOutside } from '~/hooks/useClickOutside'
import { useShare } from './useShare'
import { Button } from '~/components/general/Button'

import { trackEvent } from '~/utils/tracking'
import { useLoaderData } from '@remix-run/react'
import { useRootContext } from '~/hooks/useRootContext'
import classNames from 'classnames'
import { fadeInFadeOutTw } from '~/styles/mixins'
import { CategoryArticlePageData } from '~/routes/career-advice.$slug'

export type ShareProps = {
  articleTitle: string
  articleAbstract: string | undefined
}
export const Share = ({ articleTitle, articleAbstract }: ShareProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const [isOpened, setIsOpened] = useState(false)
  useClickOutside(ref, () => setIsOpened(false))
  const { links } = useShare({ articleTitle, articleAbstract })
  const { currentCategory } = useLoaderData() as Pick<CategoryArticlePageData, 'currentCategory'>
  const { url } = useRootContext()

  return (
    <div className="relative inline-block" ref={ref}>
      <Button
        iconRight={<ShareIcon />}
        type={'button'}
        color={'white'}
        className={
          '!p-0 !size-13 justify-center border-transparent !bg-neutral-5 hover:!bg-neutral-10 active:!bg-neutral-10'
        }
        onClick={() => {
          setIsOpened((isOpened) => !isOpened)
          trackEvent('click_share_menu', {
            content_id: articleTitle,
            category: currentCategory?.fields.name || '',
          })
        }}
      />

      <ul
        className={classNames(
          'absolute shadow-light_high right-0 p-0 m-0 bg-white rounded-3xl overflow-hidden z-1',
          fadeInFadeOutTw(isOpened),
        )}
        style={{ top: 'calc(100% + 6px)' }}
      >
        {links.map(({ link, label, Icon }) => (
          <li className="text-s list-none" key={link}>
            <a
              className="flex items-center p-4 whitespace-nowrap transition-colors duration-200 hover:bg-neutral-5 [&>svg]:flex-shrink-0 [&>svg]:mr-2"
              href={link}
              target="_blank"
              rel="noreferrer"
              onClick={() => {
                trackEvent('click_share_menu', {
                  website_host: 'career.io',
                  label: 'resume_examples',
                  category: currentCategory?.fields.name || '',
                  social: label,
                  cta: 'share_social',
                  url: url.href,
                })
              }}
            >
              <Icon width={24} height={24} /> {label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}
